export default () => ({
    first_name       : '',
    last_name        : '',
    address_primary  : '',
    address_secondary: '',
    city             : '',

    is_international_customer: false,
    //us customer
    state                    : '',
    zip                      : '',
    // international customer
    province                 : '',
    postal_code              : '',
    country                  : '',

    phone               : '',
    email               : '',
    email_confirmation  : '',
    local_accommodations: '',

    //reservation
    date_pickup     : null,
    date_return     : null,
    pickup_day      : 'day_of',
    pickup_hour     : '12:00:00',
    reservees_number: 1,
    is_delivery     : 0,
    is_seasonal     : 0,
    additional_info : '',
    coupon_id : '',
    return_day_after: 'no',

    _type: 'kiosk',
    _meta: {},
    is_from_vue: 1,
    deposit: 0,
    gender_is_on: 1,
    single_day_type: '',
    special_fee_total: 0,
    group_link_id: 0,
    location: '',
});
